import React from 'react';
import { Link } from 'react-router-dom';
import { FacebookIcon, MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { LOGO_URL, navigation } from '../data/site';
export function Footer() {
  return <footer className="bg-nuit text-creme" data-id="element-10" data-mp="32onll67cnuaj">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 md:grid-cols-[1.4fr_1fr_1fr]" data-id="element-11" data-mp="32lrlpcbxyvjg">
        <div data-id="element-12" data-mp="36nd4tff2k623">
          <img src={LOGO_URL} alt="Les Magiciens de la Nuit" className="h-16 w-auto rounded-lg bg-grege p-2" data-id="element-13" data-mp="36n3axgqwler4" />
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-creme/70" data-id="element-14" data-mp="37fu95czww38">
            Association culturelle en pays de Caux. Depuis plus de trente ans, nous créons des
            spectacles son et lumière et faisons vivre les arts au village, toute l’année.
          </p>
          <a href="https://www.facebook.com" className="mt-6 inline-flex items-center gap-2 rounded-full border border-creme/20 px-4 py-2 text-sm transition-colors duration-150 ease-out hover:border-soleil hover:text-soleil" data-id="element-15" data-mp="29yxdbdsefmmc">
            <FacebookIcon className="h-4 w-4" aria-hidden="true" data-id="element-16" data-mp="3lbdbmpwng3k8" />
            Suivre notre actualité
          </a>
        </div>

        <nav aria-label="Pages du site" data-id="element-17" data-mp="3v89f2h7oxzhx">
          <h2 className="font-display text-sm font-semibold uppercase tracking-[0.16em] text-soleil" data-id="element-18" data-mp="3v9axj6r1do9o">
            Le site
          </h2>
          <ul className="mt-5 space-y-2.5 text-sm text-creme/80" data-id="element-19" data-mp="830iphfda2zy">
            {navigation.map(item => <li key={item.label} data-id="element-20" data-mp="34723g4s9vvk">
                <Link to={item.href} className="transition-colors duration-150 ease-out hover:text-soleil" data-id="element-21" data-mp="335u5kj2dpi2">
                  {item.label}
                </Link>
              </li>)}
            <li data-id="element-22" data-mp="qthxsj7a102u">
              <Link to="/espace-adherent" className="transition-colors duration-150 ease-out hover:text-soleil" data-id="element-23" data-mp="qt03vt836xy3">
                Espace adhérent
              </Link>
            </li>
          </ul>
        </nav>

        <div data-id="element-24" data-mp="tt07un1zcgow">
          <h2 className="font-display text-sm font-semibold uppercase tracking-[0.16em] text-soleil" data-id="element-25" data-mp="tta06hahyzxr">
            Nous trouver
          </h2>
          <ul className="mt-5 space-y-3.5 text-sm text-creme/80" data-id="element-26" data-mp="13t0xsructv22">
            <li className="flex gap-3" data-id="element-27" data-mp="18k0rlo86fx0c">
              <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-soleil" aria-hidden="true" data-id="element-28" data-mp="18l2c0jb31vuq" />
              Salle de la Concorde, 76540 Valmont
            </li>
            <li className="flex gap-3" data-id="element-29" data-mp="1hkfeut4pbm6h">
              <MailIcon className="mt-0.5 h-4 w-4 shrink-0 text-soleil" aria-hidden="true" data-id="element-30" data-mp="1hje28k81ermn" />
              <a href="mailto:contact@lesmagiciensdelanuit.fr" className="hover:text-soleil" data-id="element-31" data-mp="1mktpmixota87">
                contact@lesmagiciensdelanuit.fr
              </a>
            </li>
            <li className="flex gap-3" data-id="element-32" data-mp="3obol19nzf7ee">
              <PhoneIcon className="mt-0.5 h-4 w-4 shrink-0 text-soleil" aria-hidden="true" data-id="element-33" data-mp="3ocpz7n0aoa0c" />
              02 35 00 00 00
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-creme/10" data-id="element-34" data-mp="2ag5dynhr76f2">
        <div className="mx-auto flex max-w-7xl flex-col gap-2 px-6 py-5 text-xs text-creme/50 sm:flex-row sm:items-center sm:justify-between" data-id="element-35" data-mp="2agygfc9oj9re">
          <p data-id="element-36" data-mp="21nv457art2yc">© {new Date().getFullYear()} Les Magiciens de la Nuit — association loi 1901.</p>
          <div className="flex gap-5" data-id="element-37" data-mp="1woi8py5u2nk5">
            <Link to="/mentions-legales" className="hover:text-creme" data-id="element-38" data-mp="1wpjtiucniof2">
              Mentions légales
            </Link>
            <Link to="/confidentialite" className="hover:text-creme" data-id="element-39" data-mp="2tbn32itkcxhr">
              Confidentialité
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}